// Shim for x402 (HTTP 402 payments) — a transitive dep of @privy-io/react-auth.
// Privy's CJS build imports `x402/client` side-effectfully and calls a handful
// of its helpers from internal payment flows we don't use (onramps, funding,
// bridging). The upstream x402 package bundles its own nested @solana/* tree
// at 5.5.1 which breaks the Gatsby webpack build because its internal
// `@solana/instruction-plans@5.5.1` resolves `@solana/transactions` to the
// hoisted 2.0.0 (Trezor's copy) which is missing the exports it expects.
//
// We alias x402 AND every `x402/<sub>` import to this file. The functions
// below are typed to match what Privy reads from the module at top-level; if
// you ever trigger Privy's fiat/onramp/funding flows, replace this shim.
const identity = (x) => x;
const empty = () => null;
const emptyStr = () => "";

module.exports = {
  // Used by Privy's request wrappers
  appendDataSuffix: identity,
  createPaymentHeader: emptyStr,
  selectPaymentRequirements: empty,

  // Privy reads `.current` from the module sometimes
  current: {},

  // Namespaces exported from x402 root that we stub as empty
  shared: {},
  schemes: {},
  verify: empty,
  facilitator: {},
  paywall: {},
  types: {},
  client: {},
};

// Support both `require("x402")` and `require("x402/client")` — since webpack
// alias targets this single file, any sub-path import gets the same module.
module.exports.default = module.exports;
